export const QUOTE = {
  fab: 'quote-fab',
  fabBadge: 'quote-fab-badge',
  drawer: 'quote-drawer',
  drawerClose: 'quote-drawer-close',
  drawerEmpty: 'quote-drawer-empty',
  drawerItemsList: 'quote-drawer-items',
  drawerClearAll: 'quote-drawer-clear',
  drawerSubmit: 'quote-drawer-submit',
  drawerSuccess: 'quote-drawer-success',

  itemRow: (id) => `quote-item-${id}`,
  itemQtyInput: (id) => `quote-item-qty-${id}`,
  itemUnitToggle: (id) => `quote-item-unit-${id}`,
  itemIncrement: (id) => `quote-item-inc-${id}`,
  itemDecrement: (id) => `quote-item-dec-${id}`,
  itemRemove: (id) => `quote-item-remove-${id}`,

  addBtn: (id) => `add-to-quote-${id}`,

  // form fields
  formBusiness: 'quote-form-business',
  formName: 'quote-form-name',
  formEmail: 'quote-form-email',
  formPhone: 'quote-form-phone',
  formNotes: 'quote-form-notes',
};

export const ADMIN_QUOTES = {
  panel: 'admin-quotes-panel',
  filter: (slug) => `admin-quotes-filter-${slug}`,
  export: 'admin-quotes-export-csv',
  row: (id) => `admin-quote-row-${id}`,
  status: (id) => `admin-quote-status-${id}`,
  del: (id) => `admin-quote-delete-${id}`,
  toggle: (id) => `admin-quote-toggle-${id}`,
  navTab: 'admin-nav-quotes',
};
